import { Typography } from '@material-ui/core';
import React from 'react';

const NotAllowed = () => (
  <Typography variant='h2'> Access is not allowed! ⛔️</Typography>
);

export default NotAllowed;
